import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export function getMatchHubCurrentTablePositionsCardStyles(theme: Theme) {
  return StyleSheet.create({
    tableHeaderRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingBottom: theme.spacing.sm,
      marginBottom: theme.spacing.xs,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[200],
    },
    tableHeaderSpacer: {
      flex: 1,
      minWidth: 0,
    },
    headerLabels: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    headerLabel: {
      ...theme.typography.caption,
      color: theme.gray[500],
      textAlign: 'right',
    },
    colP: {
      width: 22,
    },
    colGoals: {
      width: 44,
    },
    colGd: {
      width: 34,
    },
    colPts: {
      width: 30,
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: theme.spacing.sm,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[200],
    },
    rowLast: {
      borderBottomWidth: 0,
    },
    left: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      minWidth: 0,
      gap: theme.spacing.xs,
    },
    rank: {
      width: 22,
      ...theme.typography.labelSmall,
      color: theme.gray[800],
      fontWeight: '700',
    },
    teamName: {
      ...theme.typography.bodySmall,
      color: theme.gray[900],
      fontWeight: '600',
      flex: 1,
      minWidth: 0,
    },
    statCell: {
      ...theme.typography.bodySmall,
      color: theme.gray[800],
      textAlign: 'right',
    },
    seeAllWrap: {
      alignItems: 'center',
      marginTop: theme.spacing.sm,
    },
    seeAll: {
      ...theme.typography.caption,
      color: theme.gray[500],
      fontWeight: '600',
    },
    seeAllPressed: {
      opacity: 0.65,
    },
    seeAllHovered: {
      opacity: 0.85,
    },
  });
}
